(function () {
    var SEARCH_RESULTS_PATH = '/search';
    var SEARCHANISE_CONTAINERS =
      '.snize-ac-results, .snize-ac-results-mobile, ' +
      '#snize_results, .snize-search-results';

    // Searchanise admin sets ResultsFormPath to /pages/search-results-page.
    // Override to Shopify's canonical /search so "View all", Enter, and
    // /search?q=… all land on templates/search.json.
    function patchSearchanisePaths() {
      var sa = window.Searchanise;
      if (!sa) return false;
      if (sa.options) {
        sa.options.ResultsFormPath = SEARCH_RESULTS_PATH;
        sa.options.ResultsDiv = '#snize_results';
      }
      if (sa.userOptions) {
        sa.userOptions.ResultsFormPath = SEARCH_RESULTS_PATH;
        sa.userOptions.ResultsDiv = '#snize_results';
      }
      return true;
    }

    if (!patchSearchanisePaths()) {
      var pathTries = 0;
      var pathIv = setInterval(function () {
        pathTries++;
        if (patchSearchanisePaths() || pathTries > 50) clearInterval(pathIv);
      }, 100);
    }

    // Belt-and-suspenders: force View all to /search even if config loaded late.
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var viewAll = target.closest(
          '.snize-view-all-link, .snize-view-all-row, a[class*="view-all"], .snize-ac-view-all'
        );
        if (!viewAll) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var input = document.querySelector(
          '#cmdk-input, input.snize-search-box[name="q"], input[name="q"].snize-search-box'
        );
        var q = (input && input.value ? input.value : '').trim();
        var url = SEARCH_RESULTS_PATH + (q ? '?q=' + encodeURIComponent(q) : '');
        window.location.href = url;
      },
      true
    );
    var CART_ADD_URL = /\/cart\/add(\.js)?(\?|#|$)/;
    var CLICK_WINDOW_MS = 2000;

    var lastSearchaniseClick = 0;

    function markSearchaniseClick() {
      lastSearchaniseClick = Date.now();
    }

    function clickIsFromSearchanise() {
      return Date.now() - lastSearchaniseClick < CLICK_WINDOW_MS;
    }

    // Capture phase so we catch the click before Searchanise's handler runs.
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (target.closest(SEARCHANISE_CONTAINERS)) {
          markSearchaniseClick();
        }
      },
      true
    );

    /* Fetch the latest cart and dispatch the theme's cart:update event. */
    function refreshAndDispatch() {
      fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart fetch failed');
          return r.json();
        })
        .then(function (cart) {
          if (!cart || typeof cart.item_count !== 'number') return;
          var evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'searchanise',
              data: {
                source: 'searchanise',
                itemCount: cart.item_count,
                sections: {}
              }
            }
          });
          document.dispatchEvent(evt);
        })
        .catch(function () {
          // Swallow — the cart state will self-correct on next page load.
        });
    }

    // --- Intercept fetch ---
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input, init) {
        var url =
          typeof input === 'string'
            ? input
            : (input && input.url) || '';
        var promise = origFetch.apply(this, arguments);

        if (CART_ADD_URL.test(url) && clickIsFromSearchanise()) {
          promise
            .then(function (resp) {
              // Clone before anyone reads the body.
              if (resp && resp.ok) refreshAndDispatch();
            })
            .catch(function () {
              // Swallow — do not interfere with the caller's error path.
            });
        }

        return promise;
      };
    }

    // --- Intercept XMLHttpRequest (legacy path) ---
    var xhrProto = XMLHttpRequest.prototype;
    var origOpen = xhrProto.open;
    xhrProto.open = function (method, url) {
      this.__searchaniseUrl = url || '';
      return origOpen.apply(this, arguments);
    };

    var origSend = xhrProto.send;
    xhrProto.send = function () {
      var xhr = this;
      var url = xhr.__searchaniseUrl || '';
      if (CART_ADD_URL.test(url) && clickIsFromSearchanise()) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) refreshAndDispatch();
        });
      }
      return origSend.apply(this, arguments);
    };
  })();
